import { useEffect, useRef } from "react";

export function usePageTitle(title: string): void {
  const prevTitleRef = useRef<string>(document.title);

  useEffect(() => {
    const prev = prevTitleRef.current;
    document.title = title ? `${title} — Nashid` : "Nashid";
    return () => {
      document.title = prev;
    };
  }, [title]);
}
